import { faker } from '@faker-js/faker'

import { asBuilder } from '../asBuilder'
import { AdminProgressReviewRewardStatusRequest } from '../../contracts/review/AdminProgressReviewRewardStatusRequest'

export const getAdminProgressReviewRewardStatusRequest = asBuilder((): AdminProgressReviewRewardStatusRequest => {
  return {
    reviewIds: faker.helpers.multiple(() => faker.number.int()),
    rewardType: 'COMPLETED_PROGRESSES_WITH_MINIMUM_COUNTS',
    rewardStatus: faker.helpers.arrayElement(['PENDING', 'COMPLETED', 'REJECTED']),
  }
})
